"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubProcess = void 0;
const Constants_1 = require("../Constants");
const ActivityBase_1 = require("./ActivityBase");
/**
 * Describes a BPMN Subprocess.
 *
 * Technically they work like normal processes, except that they exist only
 * within another process and are treated like an activity for that process.
 */
class SubProcess extends ActivityBase_1.Activity {
    constructor() {
        super(...arguments);
        this.flowNodes = [];
        this.sequenceFlows = [];
        this.associations = [];
        this.dataStoreReferences = [];
        this.dataObjectReferences = [];
        this.dataObjects = [];
    }
    get bpmnType() {
        return Constants_1.BpmnType.subProcess;
    }
}
exports.SubProcess = SubProcess;
//# sourceMappingURL=SubProcess.js.map